import { h, VNode } from 'vue';
import type { Router } from 'vue-router';

export function useTaskCreatedAlert(router: Router): { content: (publicId: string, message: string, linkText: string) => VNode }
{
    const content = (publicId: string, message: string, linkText: string): VNode =>
    {
        const location = router.resolve({ name: 'renter-tasks-edit', params: { publicId } });

        return h('div', [
            message,
            h('br'),
            h('a', {
                href: location.href,
                class: 'text-reset text-decoration-underline fw-bold',
                onClick: (e: MouseEvent) =>
                {
                    if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)
                        return;

                    e.preventDefault();
                    router.push(location.fullPath);
                }
            }, linkText)
        ]);
    };

    return { content };
}
